import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../api/axiosConfig";
import Swal from "sweetalert2";
import MainLayout from "../MainLayout";
import "../../index.css";
import Loader from "../loader";
import QZTrayService from "../../api/qz-tray-service";
import { htmlToESCPOS } from "../../api/escpos-image";
import NotaVentaView from "../PDF/NotaVentaView"; // importar el componente

const ImpresionTickets = () => {
  const location = useLocation();
  const idPedido = location.state?.idPedido;
  const [loading, setLoading] = useState(true);
  const [listo, setListo]     = useState(false);

  // Refs para los 3 divs ocultos que renderizan cada nota
  const refCliente = useRef(null);
  const refAdmin   = useRef(null);
  const refLab     = useRef(null);

  if (!idPedido) {
    Swal.fire({
      title: "¡No hay ID de pedido!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Regresar",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) window.location.href = "/dashboard";
    });
  }

  useEffect(() => {
    QZTrayService.connect();

    // Esperar a que los NotaVentaView ocultos terminen de cargar
    // Los componentes internos llaman a sus propias APIs — solo esperamos un momento
    const timer = setTimeout(() => {
      setLoading(false);
      setListo(true);
    }, 4000); // 4 segundos para que carguen datos + logo + QR

    return () => {
      clearTimeout(timer);
      QZTrayService.disconnect();
    };
  }, []);

  const imprimirTicket = async (ref) => {
  if (!ref.current) return;

  try {
    Swal.fire({
      title: 'Preparando impresión...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const escposBytes = await htmlToESCPOS(ref.current);

    // ✅ Conversión segura en chunks — sin stack overflow
    let binary = '';
    const chunkSize = 8192;
    for (let i = 0; i < escposBytes.length; i += chunkSize) {
      const chunk = escposBytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode(...chunk);
    }
    const base64 = btoa(binary);

    const success = await QZTrayService.printData([
      { type: 'raw', format: 'base64', data: base64 }
    ]);

    Swal.close();

    if (!success) {
      Swal.fire("Error", "No se pudo imprimir. Verifica que la impresora esté conectada.", "error");
    }

  } catch (error) {
    Swal.close();
    console.error("Error al imprimir:", error);
    Swal.fire("Error", "No se pudo imprimir el ticket", "error");
  }
};

  return (
    <MainLayout>
      {/* Divs OCULTOS que renderizan las notas — html2canvas los captura */}
      <div style={{ position: 'fixed', left: '-9999px', top: 0, zIndex: -1 }}>
        <div ref={refCliente} style={{ width: '265px', overflow: 'hidden' }}>
          <NotaVentaView forceId={idPedido} forceTipoNota="0" />
        </div>
        <div ref={refAdmin} style={{ width: '265px', overflow: 'hidden' }}>
          <NotaVentaView forceId={idPedido} forceTipoNota="1" />
        </div>
        <div ref={refLab} style={{ width: '265px', overflow: 'hidden' }}>
          <NotaVentaView forceId={idPedido} forceTipoNota="2" />
        </div>
      </div>

      <div style={{ display: "grid" }}>
        <Loader isLoading={loading} />
        <h2 style={{ marginTop: "12%", textAlign: "center", marginBottom: "30px", fontWeight: "700" }}>
          Generación de Tickets
        </h2>
        <p style={{ textAlign: "center", marginBottom: "10px", fontSize: "20px" }}>
          Haz clic en cada botón para imprimir el ticket correspondiente.
        </p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "50%" }}>
            <button
              className="btn btn-primary"
              onClick={() => imprimirTicket(refCliente)}
              disabled={!listo}
            >
              Imprimir Ticket Cliente
            </button>
            <button
              className="btn btn-primary"
              onClick={() => imprimirTicket(refAdmin)}
              disabled={!listo}
            >
              Imprimir Ticket Administrador
            </button>
            <button
              className="btn btn-primary"
              onClick={() => imprimirTicket(refLab)}
              disabled={!listo}
            >
              Imprimir Ticket Laboratorio
            </button>
          </div>
        </div>
        <button
          className="btn btn-secondary"
          style={{ margin: "80px auto" }}
          onClick={() => {
            QZTrayService.disconnect();
            window.location.href = "/dashboard/pedidos";
          }}
        >
          Regresar
        </button>
      </div>
    </MainLayout>
  );
};

export default ImpresionTickets;